import * as React from "react";

function SvgClose(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 307.2 307.2" {...props}>
      <path d="M307.2 24.136L283.064 0 153.6 129.469 24.136 0 0 24.136 129.464 153.6 0 283.064 24.136 307.2 153.6 177.736 283.064 307.2l24.136-24.136L177.736 153.6z" />
    </svg>
  );
}

export default SvgClose;
